import { CKBox, CKCheckbox } from 'clearkit';

import { usePlatformAccess } from '~/hooks/account/usePlatformAccess';

export default function UpgradePlanItem({
  name,
  title,
  description,
  values,
  onChange,
  className,
  addon,
}) {
  const checked = values[name];
  const platformAccess = usePlatformAccess();
  const disabled = platformAccess[addon];

  return (
    <CKBox
      className={classnames('p-4', className, {
        'bg-blue-0 border-blue-200': checked && !disabled,
        'bg-gray-0 border-gray-200': disabled,
      })}
      key={name}
    >
      <CKCheckbox
        checked={checked || disabled}
        disabled={disabled}
        id={`upgrade-plan-${name}`}
        label={
          <span className="block ml-2">
            <span className="block text-base font-medium">{title}</span>
            <span>{description}</span>
          </span>
        }
        name={name}
        onChange={(event) => onChange(name, event.target.checked)}
      />
    </CKBox>
  );
}
